import { render, staticRenderFns } from "./HotelOfferTariff.vue?vue&type=template&id=c410bec2&lang=pug&"
import script from "./HotelOfferTariff.vue?vue&type=script&lang=ts&"
export * from "./HotelOfferTariff.vue?vue&type=script&lang=ts&"
import style0 from "./HotelOfferTariff.vue?vue&type=style&index=0&id=c410bec2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports